import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useOrderForm } from "@/components/orders/useOrderForm";
import { OrderProductField } from "@/components/orders/OrderProductField";
import { OrderScheduleFields } from "@/components/orders/OrderScheduleFields";
import { OrderAutoNote } from "@/components/orders/OrderAutoNote";

export default function OrderFormModal({ open, onOpenChange, order, prefill, onSubmit, bomItems = [] }) {
  const f = useOrderForm({ open, order, prefill, bomItems, onSubmit, onOpenChange });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[95vw] max-w-4xl max-h-[80vh] flex flex-col overflow-hidden" data-testid="order-form-modal">
        <DialogHeader>
          <DialogTitle className="font-display">{order ? `Edit Order ${order.order_code}` : "New Production Order"}</DialogTitle>
          <DialogDescription>Define product, quantity, schedule and line. Completion time is estimated automatically.</DialogDescription>
        </DialogHeader>
        <form onSubmit={f.submit} className="flex flex-col flex-1 min-h-0">
          <div className="flex-1 min-h-0 overflow-y-auto space-y-4 pr-2" data-testid="order-form-body">
          <OrderProductField form={f.form} manufacturedItems={f.manufacturedItems} value={f.productValue} onSelect={f.onSelectProduct} />
          <OrderScheduleFields form={f.form} set={f.set} unit={f.productUnit} />
          <OrderAutoNote />
          </div>
          <DialogFooter className="sm:justify-between shrink-0 pt-4 mt-3 border-t border-slate-100">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button type="submit" className="bg-blue-600 hover:bg-blue-700" disabled={f.saving || !f.form.product_name} data-testid="order-form-submit-button">
              {f.submitLabel}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
